import Link from '@mui/material/Link';
import { observer } from 'mobx-react-lite';
import { MouseEvent } from 'react';
import {
  Column,
  DataGrid,
  Icon,
  selectableColumn,
} from '../../../../../../../components';
import S3File from '../../../store/S3File';
import S3Files from '../../../store/S3Files';
import classes from './FileList.module.css';

function createColumns(onNavigate: (url: string) => void): Column<S3File>[] {
  return [
    selectableColumn(),
    {
      header: 'Name',
      id: 'name',
      renderCell(file) {
        return <FileItem file={file} onNavigate={onNavigate} />;
      },
    },
    {
      header: 'Size',
      id: 'displaySize',
      textAlign: 'right',
    },
    {
      header: 'Modified',
      id: 'displayModified',
      textAlign: 'right',
    },
  ];
}

export default observer(function FileList({
  files,
  onNavigate = () => {},
}: {
  files: S3Files;
  onNavigate?: (url: string) => void;
}) {
  return <DataGrid columns={createColumns(onNavigate)} data={files.items} />;
});

function FileItem({
  file,
  onNavigate = () => {},
}: {
  file: S3File;
  onNavigate?: (url: string) => void;
}) {
  function onDirClick(e: MouseEvent<HTMLAnchorElement>) {
    e.preventDefault();
    const href = e.currentTarget.getAttribute('href');
    if (href) {
      onNavigate?.(href);
    }
  }

  if (file.isDir) {
    return (
      <Link href={file.url} onClick={onDirClick}>
        <Icon className={classes.icon} icon={file.icon} size="small" />
        {file.name}
      </Link>
    );
  }

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <div
      className={classes.fileName}
      onClick={file.toggleSelection}
      role="button"
      tabIndex={-1}
      title={file.url}
    >
      <Icon className={classes.icon} icon={file.icon} size="small" />
      {file.name}
    </div>
  );
}
